import { z } from 'zod';

export type ModuleTypeEnum = 'VENDOR' | 'WORK_ORDER_ATTEMPT' | 'DELIVERY_UPDATE' | 'PROCESS_BILLING';

// ==================== Core Media Types ====================
export type MediaType = 'IMAGE' | 'VIDEO' | 'DOCUMENT' | 'AUDIO';

export interface Media {
  mediaId?: string; // uuid
  type: MediaType;
  mimeType: string;
  bucketName: string;
  path: string;
  baseUrl: string;
}

// ==================== Requests ====================

export interface MediaCreateRequest {
  mimeType: string;
  fileName?: string | null;
  uploadedFor: ModuleTypeEnum;
}

export const MediaBaseResponseSchema = z
  .object({
    mediaId: z.string().uuid(),
    type: z.string(),
    mimeType: z.string(),
    path: z.string(),
    bucketName: z.string(),
    baseUrl: z.string(),
    uploadedById: z.string().uuid(),
    metadata: z.record(z.string()),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date(),
  })
  .nullish();

export const MediaResponseSchema = z
  .object({
    media: MediaBaseResponseSchema.optional(),
    presignedPost: z
      .object({
        url: z.string().url().nullish(),
        fields: z
          .object({
            key: z.string(),
            'content-type': z.string(),
            'x-amz-meta-media-id': z.string(),
            'x-amz-meta-original': z.string(),
            bucket: z.string(),
            'X-Amz-Algorithm': z.string(),
            'X-Amz-Credential': z.string(),
            'X-Amz-Date': z.string(),
            Policy: z.string(),
            'X-Amz-Signature': z.string(),
          })
          .optional()
          .nullish(),
      })
      .nullish(),
  })
  .nullish();

export type MediaBaseResponse = z.infer<typeof MediaBaseResponseSchema>;

// ==================== Responses ====================

export interface PresignedPostFields {
  key: string;
  'content-type': string;
  'x-amz-meta-media-id': string;
  'x-amz-meta-original': string;
  bucket: string;
  'X-Amz-Algorithm': string;
  'X-Amz-Credential': string;
  'X-Amz-Date': string;
  Policy: string;
  'X-Amz-Signature': string;
}

export interface MediaResponse {
  media?: MediaBaseResponse;
  presignedPost?: {
    url: string;
    fields?: PresignedPostFields;
  };
}

export interface MediaGetUrlResponse {
  url: string;
}
